import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { createUser, getRole, updateUser } from "../services/userApi";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import { deleteMedia, uploadImage } from "../../Media/services/mediaApi";
import FormField from "../../../Components/Common/Form/FormField";
import SelectField from "../../../Components/Common/Form/SelectField";
import FileField from "../../../Components/Common/Form/FileField";

const AddEditUserForm = ({ modal, setModal, toggle, selectedUser }) => {
  
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);

  const { isLoading: isLoadingRole, isError: isErrorRole, error, data: roles } = useQuery("roles", getRole);
  const category = "user";

  const handlePhotoFileUpdate = (fileItems) => {
    setImage(fileItems.length > 0 ? fileItems[0].file : null);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Oups!!! Veuillez renseigner le nom complet"),
    email: Yup.string().email("Veuillez renseigner une adresse email valide").required("Veuillez renseigner l'adresse email"),
    phone: Yup.number().required("Son numéro de téléphone svp"),
    address: Yup.string().required("Veuillez renseigner l'adresse"),
  });

  const initialValues = selectedUser ? {
    name: selectedUser?.name,
    email: selectedUser?.email,
    phone: selectedUser?.phone,
    address: selectedUser?.address || "",
    licenseNumber: selectedUser?.licenseNumber || "",
    role: selectedUser?.role?.name || "",
    fileName: selectedUser.fileName || "",
  } : {
    name: "",
    email: "",
    phone: "",
    address: "",
    status:"ACTIF",
    licenseNumber: "",
    role: "",
    fileName: "",
    password: "Syst@link123"
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      let fileName = values.fileName;
      try {
        if (image) {
          const response = await uploadImage(category, image);
          fileName = response?.name;
        }
        const username = values?.email;
        const userData = {
          ...values,
          username,
          fileName,
          role: { name: values.role}
        };
        if (selectedUser) {
          await updateUser(selectedUser?.id, userData);
          toast.success("L'utilisateur a été modifié avec succès",
            {
              duration: 10000,
            }
          );
        } else {
          await createUser(userData);
          toast.success("Utilisateur ajouté avec un mot de passe par défaut Syst@link123 🎉");
        }
        await queryClient.invalidateQueries("users");
        toggle();
        formik.resetForm();
      } catch (error) {
        toast.error(`Erreur: ${error?.message || error}`);
        if (image && fileName) {
          try {
            await deleteMedia(fileName);
          } catch (deleteError) {
            console.error("Erreur lors de la suppression de l'image :", deleteError);
          }
        }
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedUser]);

  const modalTitle = selectedUser ? "Édition" : `Ajout`;

    const rolesOptions = [
      { id: "ADMIN", name: "Administrateur" },
      { id: "INTERVENANT", name: "Intervenant" },
    ];
    
  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "700px" }}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        {modalTitle} d'un utilisateur <UserAddOutlined />
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row>
            <FileField
                label="Photo de profile"
                name="fileName"
                formik={formik}
                file={image}
                onUpdateFiles={handlePhotoFileUpdate}
                helperText="La photo de profil est optionnelle"
                colSize={12}
              />
            <FormField label="Prénom et Nom" name="name" formik={formik} colSize={6} placeholder="Entrez le nom complet"/>
            <FormField label="Email" name="email" formik={formik} type="email" colSize={6} placeholder="Entrez son adresse email"/>
            <FormField label="Téléphone" name="phone" formik={formik} type="number" colSize={6} placeholder="Entrez le numéro de téléphone"/>
            <SelectField label="Role" name="role" formik={formik} options={rolesOptions} nameSelect="le role" colSize={6} />
            <FormField label="Adresse" name="address" formik={formik} colSize={6} placeholder="Entrez son adresse"/>
            
          </Row>
                    
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>
          <Button type="submit" className="btn btn-soft-success" disabled={isLoading}>
            {isLoading ? <Spin size="small" /> : (selectedUser ? "Modifier" : "Ajouter")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddEditUserForm;
